import React from 'react';
import { times } from 'lodash-es';

import Skeleton from '../../../../components/Skeleton';

const ReportsSkeleton = () => (
  <div className="report-component-skeleton-wrapper">
    {times(6).map(n => (
      <div key={n} className="report-component-skeleton">
        <div className="img-box">
          <Skeleton height={165} width={340} borderRadius="unset" />
        </div>
        <div className="info-box">
          <Skeleton height={20} width={290} />
          <Skeleton height={14} width={140} />
          <Skeleton height={72} width={290} />
          <Skeleton height={32} width={290} />
        </div>
      </div>
    ))}
  </div>
);

export default ReportsSkeleton;
